/* v2-cart-share.js - "Share Bag" and "Share Wishlist".
   Builds an identity-free link and hands it to the native share sheet (or a copy-link panel).
   Bag link: variant ids, quantities, line properties (bundle markers and fitting details survive) and the Packaging
   choice, read from /cart.js. Wishlist link: the saved variant ids, their product paths and titles, the extra
   choices saved with the heart, and the line properties each piece would get when moved to the bag.
   Neither carries customer data, the cart note, the cart token or a checkout URL.
   The link is prepared before the tap, because iOS Safari ends the tap's permission to share quickly. */
(function () {
if (window.__v2CartShare) return;
window.__v2CartShare = true;

var MAX_URL = 6000;
var MAX_LINES = 20;
var MAX_WISH = 30;
var ATTRS = ['Packaging'];
var GIFT_DENY = ['recipient email', 'recipient name', 'message', 'send on'];
var KINDS = ['cart', 'wish'];
var state = {};
KINDS.forEach(function (k) { state[k] = { url: null, dirty: true, building: null, tooLarge: false, timer: 0 }; });

/* Link format v2 (shorter). Property names that the theme uses all the time are sent as a number from this list, and
   properties are sent as a flat [name, value, name, value ...] list. The same list is in v2-shared-cart.js: only ever add
   to the end of it, never reorder, or links that were already shared would decode wrongly. */
var KEYS = ['Stone', 'Metal', 'Gauge', '_Bar Length', '_Fitting', 'Fitting', 'Bar Length', 'Birthstone', 'Connector',
  'Material', 'Packaging', 'May be eligible for bundle discount', '_v2', 'Delivery', 'Ships'];
function flatProps(props, omit) {
  var out = [];
  Object.keys(props || {}).forEach(function (k) {
    if (omit && omit[k] === props[k]) return;
    var i = KEYS.indexOf(k);
    out.push(i > -1 ? i : k, String(props[k]));
  });
  return out;
}

function holder() { return document.querySelector('[data-v2cs]'); }
function str(box, name) { return (box && box.getAttribute('data-' + name)) || ''; }
function base(box) {
  var path = str(box, 'page-path') || '/pages/shared-bag';
  return location.origin + path;
}

function toB64u(bytes) {
  var s = '';
  for (var i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function gzip(bytes) {
  if (typeof CompressionStream === 'undefined') return Promise.resolve(null);
  try {
    var cs = new CompressionStream('gzip');
    var w = cs.writable.getWriter();
    w.write(bytes); w.close();
    return new Response(cs.readable).arrayBuffer().then(function (b) { return new Uint8Array(b); }, function () { return null; });
  } catch (e) { return Promise.resolve(null); }
}
function encode(obj, box, kind) {
  var bytes = new TextEncoder().encode(JSON.stringify(obj));
  return gzip(bytes).then(function (z) {
    var enc = z && z.length + 1 < bytes.length ? 'g' + toB64u(z) : 'p' + toB64u(bytes);
    var url = base(box) + '?b=' + enc + '&utm_source=' + kind + '_share';
    return url.length > MAX_URL ? null : url;
  });
}

/* ---- bag ---- */

/* Every line property is copied unchanged (so bundle markers and app-added keys survive), except private
   gift-card recipient fields and Shopify's internal __shopify_* keys. */
function packCart(cart) {
  var items = cart.items.map(function (it) {
    var props = {}, n = 0;
    Object.keys(it.properties || {}).forEach(function (k) {
      var v = it.properties[k];
      if (v == null || v === '') return;
      if (/^__shopify_/.test(k)) return;
      if (it.gift_card && GIFT_DENY.indexOf(k.toLowerCase()) > -1) return;
      props[k] = String(v); n++;
    });
    var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : null;
    var row = [it.variant_id, it.quantity, n ? flatProps(props) : 0, sp || 0];
    while (row.length > 2 && !row[row.length - 1]) row.pop();
    return row;
  });
  var out = { v: 2, i: items };
  var attrs = {}, any = false;
  ATTRS.forEach(function (k) {
    if (cart.attributes && cart.attributes[k]) { attrs[k] = String(cart.attributes[k]); any = true; }
  });
  if (any) out.a = flatProps(attrs);
  return out;
}

/* ---- wishlist ---- */

function ls(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
function saved(k) {
  var raw = ls(k);
  return raw ? raw.split(',').filter(function (x) { return x !== '' && x !== 'null'; }) : [];
}
function wishCount() { return saved('wishlist-ids').length; }
function pathOf(u) {
  try {
    var a = document.createElement('a'); a.href = u;
    return a.pathname + a.search;
  } catch (e) { return ''; }
}
/* "/products/handle?variant=1" -> "handle", or "/fr/products/handle?variant=1" -> "/fr|handle" (the store language is kept) */
function handleRef(path) {
  var m = /^(\/[a-z]{2}(?:-[a-zA-Z]{2,4})?)?\/products\/([A-Za-z0-9._~%-]+)/.exec(path || '');
  return m ? (m[1] ? m[1] + '|' : '') + m[2] : '';
}
function packWish() {
  var ids = saved('wishlist-ids'), urls = saved('wishlist-urls');
  var extras = {};
  try { extras = JSON.parse(ls('v2-wish-extras') || '{}') || {}; } catch (e) {}
  var items = [];
  ids.forEach(function (id, i) {
    var vid = parseInt(id, 10), ref = handleRef(pathOf(urls[i] || ''));
    if (!vid || !ref) return;
    var ex = extras[String(id)];
    var props = typeof window.__v2WishLineProps === 'function' ? window.__v2WishLineProps(id, { noShips: true }) : null;
    var row = [vid, ref, ex && ex.length ? ex : 0, props ? flatProps(props, { _v2: '1' }) : 0];
    while (row.length > 2 && !row[row.length - 1]) row.pop();
    items.push(row);
  });
  return items.length ? { v: 2, k: 'w', i: items } : null;
}

/* ---- building ---- */

function build(kind, box) {
  var st = state[kind];
  if (st.building) return st.building;
  box = box || holder();
  st.dirty = false;
  var made;
  if (kind === 'cart') {
    made = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        st.tooLarge = false;
        if (!cart || !cart.items || !cart.items.length) return null;
        if (cart.items.length > MAX_LINES) { st.tooLarge = true; return null; }
        return encode(packCart(cart), box, 'cart').then(function (u) { if (!u) st.tooLarge = true; return u; });
      });
  } else {
    made = Promise.resolve().then(function () {
      st.tooLarge = false;
      var data = packWish();
      if (!data) return null;
      if (data.i.length > MAX_WISH) { st.tooLarge = true; return null; }
      return encode(data, box, 'wishlist').then(function (u) { if (!u) st.tooLarge = true; return u; });
    });
  }
  st.building = made
    .then(function (url) {
      st.url = url;
      return url;
    }, function () { st.url = null; return null; })
    .then(function (u) {
      st.building = null;
      if (st.dirty) build(kind, box);
      return u;
    });
  return st.building;
}

function markDirty(kind) {
  var st = state[kind];
  st.dirty = true;
  clearTimeout(st.timer);
  if (!holder()) return;
  st.timer = setTimeout(function () { if (st.dirty && !st.building) build(kind); }, 350);
}

/* Any cart write (add, change, update, clear) makes the prepared bag link stale. */
(function () {
  var orig = window.fetch;
  if (!orig) return;
  window.fetch = function (input) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var p = orig.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { markDirty('cart'); }, function () {});
    return p;
  };
})();

/* ---- panel and sharing ---- */

function boxOf(btn) { return btn.closest('[data-v2cs]'); }
function panelFor(btn) { var c = boxOf(btn); return c && c.querySelector('[data-v2cs-panel]'); }
function closePanels() {
  Array.prototype.forEach.call(document.querySelectorAll('[data-v2cs-panel]'), function (p) { p.hidden = true; });
}
function openPanel(btn, url, message) {
  var panel = panelFor(btn); if (!panel) return;
  var input = panel.querySelector('[data-v2cs-url]');
  var msg = panel.querySelector('[data-v2cs-msg]');
  input.value = url || '';
  input.hidden = !url;
  var copy = panel.querySelector('[data-v2cs-copy]');
  if (copy) copy.hidden = !url;
  msg.textContent = message || '';
  panel.hidden = false;
  if (url) { input.focus(); input.select(); }
}

function go(btn, kind, url) {
  var box = boxOf(btn);
  if (!url) {
    var big = kind === 'wish' ? str(box, 'wish-too-large') || str(box, 'too-large') : str(box, 'too-large');
    openPanel(btn, null, state[kind].tooLarge ? big : str(box, 'failed'));
    return;
  }
  var data = kind === 'wish'
    ? { title: str(box, 'wish-title'), text: str(box, 'wish-text'), url: url }
    : { title: str(box, 'title'), text: str(box, 'text'), url: url };
  if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
    navigator.share(data).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      openPanel(btn, url);
    });
  } else {
    openPanel(btn, url);
  }
}

function share(btn) {
  var kind = btn.getAttribute('data-v2cs-kind') === 'wish' ? 'wish' : 'cart';
  var st = state[kind];
  /* Ready link: share inside the tap. Otherwise build, then share. */
  if (st.url && !st.dirty && !st.building) { go(btn, kind, st.url); return; }
  build(kind, boxOf(btn)).then(function (u) { go(btn, kind, u); });
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-v2cs-btn]');
  if (btn) {
    e.preventDefault();
    var p = panelFor(btn);
    if (p && !p.hidden) { p.hidden = true; return; }
    closePanels();
    share(btn);
    return;
  }
  var copy = e.target.closest && e.target.closest('[data-v2cs-copy]');
  if (copy) {
    var panel = copy.closest('[data-v2cs-panel]');
    var input = panel.querySelector('[data-v2cs-url]');
    var msg = panel.querySelector('[data-v2cs-msg]');
    var done = function () { msg.textContent = str(boxOf(copy), 'copied'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(input.value).then(done, function () { input.select(); });
    } else { input.select(); }
    return;
  }
  if (!(e.target.closest && e.target.closest('[data-v2cs-panel]'))) closePanels();
});
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

/* ---- keeping the drawer in step ---- */

document.addEventListener('pointerdown', function (e) {
  var b = e.target.closest && e.target.closest('[data-v2cs-btn]');
  if (!b) return;
  var kind = b.getAttribute('data-v2cs-kind') === 'wish' ? 'wish' : 'cart';
  if (state[kind].dirty && !state[kind].building) build(kind, boxOf(b));
}, true);

function syncWish() {
  var box = document.querySelector('.v2cs--drawer');
  if (!box) return;
  var empty = wishCount() === 0 ? '1' : '0';
  if (box.getAttribute('data-wish-empty') !== empty) box.setAttribute('data-wish-empty', empty);
}
window.addEventListener('storage', function () { markDirty('wish'); syncWish(); });

function watchDrawer() {
  var d = document.querySelector('cart-drawer');
  if (!d || d.__v2csWatch || typeof MutationObserver === 'undefined') return;
  d.__v2csWatch = true;
  function refresh() {
    syncWish();
    var view = d.getAttribute('data-v2c-view');
    if (!d.classList.contains('active')) return;
    if (view === 'wish') { if (state.wish.dirty && !state.wish.building) build('wish'); }
    else if (state.cart.dirty && !state.cart.building) build('cart');
  }
  new MutationObserver(refresh).observe(d, { attributes: true, attributeFilter: ['class', 'data-v2c-view'] });
  /* The wishlist rows are painted after their specs arrive; that is when every piece's properties are known. */
  var rows = d.querySelector('[data-v2c-wishrows]');
  if (rows) new MutationObserver(function () { markDirty('wish'); syncWish(); }).observe(rows, { childList: true, subtree: true });
  syncWish();
  /* Opened before this script loaded (the bag reopens after a shared link is imported): prepare the link now. */
  if (d.classList.contains('active')) refresh();
}
function init() {
  watchDrawer();
  if (document.querySelector('.v2cs--page')) build('cart');
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
